<template>
  <div id="notification">
    <comp-header
      :pageTitle="headerPageTitle"
      :leftIcon="headerLeftIcon"
      :leftClick="headerLeftAction"
    />
    <hr id="divider-fat" />
    <template v-if="notiDataList.length">
      <comp-notice-item
        v-for="noti in notiDataList"
        :key="noti.alarmId"
        :noticeType="setNoticeType(noti.status)"
        :title="noti.message"
        :userSeqId="noti.userId"
        :alarmId="noti.alarmId"
        :groupId="noti.groupId"
        :dateTime="noti.regDate"
        @agree="performInviteAgree"
        @disagree="performInviteDisagree"
      />
    </template>
    <comp-loading v-if="isLoading"></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common';
import RESPONSE from '@/constants/response';
import CompHeader from '@/components/CompHeader';
import CompNoticeItem from '@/components/CompNoticeItem';
import CompLoading from '@/components/CompLoading';

export default {
  name: 'notification',
  mixins: [common],
  components: {
    CompHeader,
    CompNoticeItem,
    CompLoading,
  },
  data() {
    return {
      headerPageTitle: this.$i18n.t('myMenu.notification'),
      headerLeftIcon: 'fa-chevron-left',

      noticeType: '',
      notiDataList: [],

      isLoading: false,
    };
  },
  methods: {
    headerLeftAction() {
      this.goPrevious();
    },
    getNotificationList() {
      this.isLoading = true;

      this.$store.dispatch('getNotificationList').then((data) => {
        if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
          this.$store.dispatch('refreshToken').then((response) => {
            if (response.status === RESPONSE.SUCCESS.CODE) {
              this.getNotificationList();
            } else {
              this.invalidateLogin();
            }
          });
        } else if (data.status === RESPONSE.SUCCESS.CODE) {
          this.notiDataList = data.data.data;
        }
        this.isLoading = false;
      });
    },
    setNoticeType(notiStatus) {
      if (notiStatus === 'NR') {
        return '';
      } else if (notiStatus === 'R') {
        return '';
      } else if (notiStatus === 'I') {
        return 'invite';
      }
      return '';
    },
    performInviteAgree(groupId, alarmId, userId) {
      const data = {
        groupId,
        alarmId,
        userId,
      };
      this.isLoading = true;

      // eslint-disable-next-line no-shadow
      this.$store.dispatch('addMember', data).then((data) => {
        if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
          this.$store.dispatch('refreshToken').then((response) => {
            if (response.status === RESPONSE.SUCCESS.CODE) {
              this.performInviteAgree();
            } else {
              this.invalidateLogin();
            }
          });
        } else if (data.status === RESPONSE.SUCCESS.CODE) {
          location.reload();
        }
        this.isLoading = false;
      });
    },
    performInviteDisagree(alarmId) {
      this.isLoading = true;

      this.$store.dispatch('disagreeInvite', { alarmId }).then((data) => {
        if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
          this.$store.dispatch('refreshToken').then((response) => {
            if (response.status === RESPONSE.SUCCESS.CODE) {
              this.performInviteAgree();
            } else {
              this.invalidateLogin();
            }
          });
        } else if (data.status === RESPONSE.SUCCESS.CODE) {
          location.reload();
        }
        this.isLoading = false;
      });
    },
  },
  created() {
    this.getNotificationList();
  },
};
</script>

<style>
#divider-fat {
  border: solid 2px lightgray;
  margin: 0 10px 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/mc6/notification.vue